import Flex from '@creditflowresearch/uilib/Flex';
import Select, { ISelectOption } from '@creditflowresearch/uilib/Select';
import { useAskAiChatContext } from '@/creditflowresearch/application/AskAiChat/context/AskAiChatContext';
import { formatVersionLabel } from '@/creditflowresearch/application/AskAiPrompts/helpers/formatVersion';
import { useUserTimeZoneContext } from '@/creditflowresearch/application/User/UserTimeZone/UserTimeZoneContext';
import styles from './promptVersionSelect.module.scss';

const DEFAULT_OPTION: ISelectOption = { value: '', label: 'Default' };

const PromptVersionSelect = () => {
  const { timeZone } = useUserTimeZoneContext();
  const {
    promptVersions,
    selectedPromptVersionId,
    selectPromptVersion,
    refreshPromptVersions,
    isGenerating,
  } = useAskAiChatContext();

  if (!promptVersions.length) {
    return null;
  }

  const options: ISelectOption[] = [
    DEFAULT_OPTION,
    ...promptVersions.map((version) => ({
      value: version.id,
      label: formatVersionLabel(version, timeZone),
    })),
  ];
  const value = options.find((option) => option.value === selectedPromptVersionId) ?? DEFAULT_OPTION;

  const handleChange = (option: ISelectOption): void => {
    selectPromptVersion(option.value ? String(option.value) : null);
  };

  return (
    <Flex align="center" gap={ 12 } dataTest="askAiPromptVersion">
      <span className={ styles.label }>Prompt version:</span>
      <div className={ styles.select }>
        <Select
          value={ value }
          options={ options }
          onChange={ handleChange }
          onOpen={ refreshPromptVersions }
          isDisabled={ isGenerating }
          isSearchable={ false }
          isNarrow
          size="S"
          menuPlacement="top"
          dataTest="askAiPromptVersionSelect"
        />
      </div>
    </Flex>
  );
};

export default PromptVersionSelect;
